import {getApiUrl} from '@/api/common-utils';
import {BaseApi} from '@/api/base-api';
import {BacklinkAnalyzerApi} from './backlink-analyzer';

export const BacklinkAnalyzerClient = new BacklinkAnalyzerApi(getApiUrl(BaseApi.BACKLINK_ENDPOINT, ''));
